<template>
  <!-- Fondo semitransparente -->
  <transition name="fade">
    <div  v-if="visible"  class="fixed inset-0 bg-black/30   flex items-center justify-center z-50"
    >

      <!-- Contenedor del modal -->
      <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-6xl p-5 transform transition-all border border-gray-200"
      > <div class="flex justify-between">
            <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;ModalModificacionMes&#62;</span>
        </div>
        <!-- Encabezado -->
        <div class="border-b pb-4 mb-6 flex justify-between items-start">
          <!-- CONTENIDO CENTRADO -->
          <div class="flex-1 text-center space-y-3">
            <div class="grid grid-cols-3 gap-4 items-start text-center">
              <div class="pt-5">
                <!-- COL 1: TÍTULO -->
                <h2 class="text-xl font-semibold text-gray-800 tracking-wide">
                  {{ this.glosa_accion }} {{ mesTexto }}
                </h2>
              </div>
              <!-- COL 2: SUBTÍTULO -->
              <div class="pt-5">
                <p class="text-gray-600 text-sm">
                  {{ nomcentro }} • {{ nomcta }}
                </p>
              </div>
              <!-- COL 3: TARJETA RESUMEN -->
              <div
                class="inline-block bg-gray-50 p-3 rounded-xl border border-gray-200 shadow-inner text-sm w-full"
              >
                <div class="grid grid-cols-3 gap-6 text-gray-700">
                  <!-- Presupuesto mes -->
                  <div class="text-gray-600 text-xs">
                    Presupuesto {{ mesTexto }}<br />
                    <span class="text-gray-600">
                      $ {{ $formatoMiles(monto_presupuesto_mes) }}
                    </span>
                  </div>

                  <!-- Operación -->
                  <div>
                    <div class="text-gray-600 text-xs">
                      {{ glosa_operacion }}<br />
                      <span class="text-gray-600">
                        $ {{ $formatoMiles(monto_modif) }}
                      </span>
                    </div>

                    <p
                      v-if="error_monto"
                      class="text-red-500 text-xs mt-1 flex items-center gap-1 justify-center"
                    >
                      ❌ Debe ingresar monto
                    </p>
                  </div>

                  <!-- Tentativo -->
                  <div class="text-gray-600 text-xs">
                    Total<br />
                    <span class="text-gray-600">
                      $ {{ $formatoMiles(presupuesto_tentativo) }}
                    </span>
                  </div>
                </div>

                <p
                  v-if="error_ingresos_insuficientes"
                  class="text-red-500 text-xs mt-2 flex items-center gap-1 justify-center"
                >
                  ❌ Monto a retirar excede al ingreso
                </p>
              </div>
            </div>
          </div>

          <!-- BOTÓN CERRAR -->
          <button
            @click="cerrar"
            class="text-gray-400 hover:text-gray-600 transition text-2xl leading-none ml-4"
            aria-label="Cerrar modal"
          >
            ✕
          </button>
        </div>

        <!-- CONTENIDO -->

        <div v-if="showForm" class="space-y-2 text-gray-700">
          <p class="text-sm text-gray-500">
            <span
              v-if="error_props"
              class="text-red-500 text-xs flex items-center gap-1"
            >
              ❌ error: falta presupuesto_id o mes
            </span>
          </p>

          <!-- BLOQUE REASIGNACIÓN -->
          <div
            class="bg-gray-50 p-2 rounded-xl border border-gray-200 shadow-inner"
          >
            <div v-if="reasignar_isOn" class="space-y-5 mb-0">
              <!-- TÍTULO -->
              <div
                v-if="saldo_por_completar > 0"
                class="font-semibold text-gray-800 text-base"
              >
                {{ glosa_reasignacion }}
                ${{ $formatoMiles(saldo_por_completar) }} pesos
              </div>

              <!-- CENTRO | CUENTA | BARRA -->
              <div class="grid grid-cols-3 gap-6 mt-0">
              
                <!-- CENTRO -->
                <div>
                  <select
                    name="centro"
                    id="centro"
                    class="border border-gray-300 rounded-lg px-3 py-2 text-sm w-full bg-white focus:ring-2 focus:ring-blue-300 transition shadow-sm"
                    :class="{ 'border-red-400 ring-red-300': error_centro }"
                    v-model="centroSelec"
                    @change="cambioCentro"
                  >
                    <option value="0">Seleccione un centro</option>
                    <option
                      v-for="item in centros"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.codigo }} - {{ item.nombre }}
                    </option>
                  </select>

                  <p
                    v-if="error_centro"
                    class="text-red-500 text-xs mt-1 flex items-center gap-1"
                  >
                    ❌ Debe seleccionar un centro
                  </p>
                </div>

                <!-- CUENTA -->
                <div>
                  <select
                    name="cuenta"
                    id="cuenta"
                    class="border border-gray-300 rounded-lg px-3 py-2 text-sm w-full bg-white focus:ring-2 focus:ring-blue-300 transition shadow-sm"
                    :class="{ 'border-red-400 ring-red-300': error_cuenta }"
                    v-model="cuentaSelec"
                    @change="cambioCuenta"
                  >
                    <option value="0">Seleccione una cuenta</option>
                    <option
                      v-for="item in cuentas"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.codigo }} - {{ item.nombre }}
                    </option>
                  </select>

                  <p
                    v-if="error_cuenta"
                    class="text-red-500 text-xs mt-1 flex items-center gap-1"
                  >
                    ❌ Debe seleccionar una cuenta
                  </p>
                </div>

                <!-- BARRA PROGRESO -->
                <div class="w-full">
                  <div
                    class="w-full bg-gray-300 rounded-full h-4 mb-1.5 overflow-hidden"
                  >
                    <div
                      class="h-4 transition-all duration-700 rounded-full"
                      :style="{
                        width: porcentaje_movimientos + '%',
                        background:
                          porcentaje_movimientos < 100
                            ? 'linear-gradient(90deg, #fb923c, #f97316)'
                            : 'linear-gradient(90deg, #22c55e, #16a34a)',
                      }"
                    ></div>
                  </div>

                  <div
                    class="flex justify-between text-xs text-gray-600 font-medium mt-1"
                  >
                    <span>0</span>
                    <span>${{ $formatoMiles(monto_modif) }}</span>
                  </div>
                </div>
              </div>

              <!-- GRILLA DE MESES -->
              <div
                v-if="puede_mostrar_meses"
                class="grid grid-cols-12 gap-1 text-center mt-2"
              >
                <!-- nombre mes -->
                <div
                  v-for="(nombre, index) in meses"
                  :key="index"
                  @click="seleccionar_mes(index + 1)"
                  class="rounded-lg cursor-pointer font-medium px-2 py-1 text-xs transition shadow-sm"
                  :class="{
                    'bg-yellow-200 text-black':
                      mesSelec === index + 1 && !error_saldo_insuficiente,
                    'bg-red-400 text-white':
                      mesSelec === index + 1 && error_saldo_insuficiente,
                    'bg-blue-100 text-blue-800 hover:bg-blue-200':
                      mesSelec !== index + 1,
                  }"
                >
                  {{ nombre }}
                </div>

                <!-- presupuesto mes -->
                <div
                  v-for="mes in 12"
                  :key="'fila2-' + mes"
                  @click="seleccionar_mes(mes)"
                  class="px-2 py-1 cursor-pointer shadow-sm font-medium text-xs transition"
                  :class="{
                    'bg-yellow-200 text-black':
                      mesSelec === mes && !error_saldo_insuficiente,
                    'bg-red-400 text-white':
                      mesSelec === mes && error_saldo_insuficiente,
                    'bg-green-100 hover:bg-green-200': mesSelec !== mes,
                  }"
                >
                  <div
                    v-if="loading"
                    class="w-4 h-4 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-1"
                  ></div>

                  {{ marca_modificacion[mes] }}
                  {{ $formatoMiles(array_monto_mensual[mes]) }}
                </div>

                <!-- monto reasignaciones -->
                <div
                  v-for="mes in 12"
                  :key="'fila3-' + mes"
                  @click="seleccionar_mes(mes)"
                  class="px-2 py-1 cursor-pointer shadow-sm font-medium text-xs transition"
                  :class="{
                    'bg-yellow-200 text-black':
                      mesSelec === mes && !error_saldo_insuficiente,
                    'bg-red-400 text-white':
                      mesSelec === mes && error_saldo_insuficiente,
                    'bg-green-100 hover:bg-green-200': mesSelec !== mes,
                  }"
                >
                  <input
                    type="text"
                    @blur="handleBlurMontoReasignacion(mes, $event)"
                    @focus="handleFocusMontoReasignacion($event)"
                    class="border px-2 py-1 text-xs w-full bg-white shadow-sm focus:ring-2 focus:ring-blue-300 outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <span class="text-xs p-3" v-if="reasignar_isOn"> presupuesto_id seleccionado: {{ presupuesto_id_Selec }}</span
          >
          <!-- ERRORES -->
          <p v-if="error_saldo_insuficiente" class="text-red-500 text-xs mt-1">
            ❌ Saldo del mes insuficiente
          </p>
          <p v-if="error_falta_selec_mes" class="text-red-500 text-xs mt-1">
            ❌ Debe seleccionar un mes
          </p>
          <p
            v-if="error_monto_modificacion_ya_alcanzado"
            class="text-red-500 text-xs mt-1"
          >
            ❌ error: monto ingresado excesivo
          </p>

          <!-- Tabla de movimientos -->
          <div v-if="reasignar_isOn" class="space-y-2 mb-2">
            <div class="text-right text-gray-500 text-xs">
              Saldo por completar: ${{ $formatoMiles(saldo_por_completar) }}
            </div>

            <div
              class="rounded-b-xl border border-gray-200 bg-white p-0 shadow"
            >
              <div class="max-h-48 overflow-y-auto">
                <table class="w-full text-xs text-gray-700">
                  <thead class="sticky top-0 bg-gray-50">
                    <tr class="border-b text-gray-600">
                      <th class="text-center py-2 px-2">Centro</th>
                      <th class="text-center py-2 px-2">Cuenta</th>
                      <th class="text-center py-2 px-2">Mes</th>
                      <th class="text-center py-2 px-2">Monto</th>
                      <th class="py-2 px-2"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="item in list_movimientos"
                      :key="item.indice"
                      class="border-b hover:bg-gray-50"
                    >
                      <td class="py-1 px-2">
                        {{ item.indice }} {{ item.centro_datos }}
                      </td>
                      <td class="py-1 px-2">
                        ({{ item.cuenta }}) {{ item.cuenta_datos }}
                      </td>
                      <td class="py-1 px-2">
                        {{ this.meses[item.objMesMonto.mes - 1] }}
                      </td>
                      <td class="py-1 px-2">
                        {{ $formatoMiles(item.objMesMonto.monto) }}
                      </td>

                      <td class="py-1 px-2">
                        <button
                          @click="borrar_movimiento(item.indice)"
                          class="bg-gray-100 hover:bg-gray-200 text-xs px-3 py-1 rounded-lg transition"
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="grid grid-cols-5 p-2 mt-0 w-full text-xs text-gray-700 bg-gray-50"
              >
                <div></div>
                <div></div>
                <div></div>
                <div class="text-right p-2">Total:</div>
                <div class="text-left p-2">
                  ${{ $formatoMiles(total_movimientos) }}

                  <p
                    v-if="error_faltan_movimientos"
                    class="text-red-500 text-xs mt-1 flex items-center gap-1"
                  >
                    ❌ Debe completar movimientos hasta sumar: ${{
                      $formatoMiles(monto_modif)
                    }}
                    pesos.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="rounded-b-xl border border-gray-200 bg-white p-3 shadow">
            <div class="grid grid-cols-2 gap-4 mt-3">
              <!-- Columna 1: Glosa -->
              <div>
                <textarea
                  v-model="glosa"
                  placeholder="Glosa..."
                  rows="1"
                  class="border border-gray-300 rounded-lg px-3 py-2 w-full bg-white shadow-sm focus:ring-2 focus:ring-blue-300 outline-none"
                ></textarea>
              </div>

              <!-- Columna 2: Upload -->
              <div class="space-y-1">
                <input
                  @change="onFileChange"
                  type="file"
                  name="file"
                  id="file-input"
                  :key="fileKey"
                  class="border border-gray-300 rounded-lg px-3 py-2 w-full bg-white shadow-sm focus:ring-2 focus:ring-blue-300 transition"
                  :class="{
                    'border-red-500': error_file,
                    'border-blue-500': !error_file,
                  }"
                />

                <div class="text-xs text-gray-500">{{ file_url }}</div>

                <!-- Barra de progreso -->
                <div v-if="uploading" class="w-full mt-2">
                  <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div
                      class="bg-blue-500 h-2 transition-all duration-200"
                      :style="{ width: uploadProgress + '%' }"
                    ></div>
                  </div>

                  <p class="text-xs text-gray-500 mt-1">
                    {{ uploadProgressGlosa }} {{ uploadProgress }}<span>%</span>
                  </p>
                </div>
                <p v-if="error_file" class="text-red-500 text-xs">
                  ❌ Debe subir archivo adjunto
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!showForm" class="space-y-2 text-gray-700">
          modificacion grabada
        </div>
        <!-- FOOTER -->
        <div  class="flex justify-end space-x-4 mt-2 pt-4 border-t text-sm text-gray-600">
            
          <button  @click="cerrar"  class="bg-gray-300 hover:bg-gray-200 text-gray-900 px-6 py-2 rounded-lg shadow-sm">
            Cerrar ventana
          </button>
          <button
            v-if="showForm === false"
            @click="pdf"
            class="px-6 py-2 rounded-lg transition font-medium"
            :class="{
              'bg-gray-100 text-gray-300 cursor-not-allowed':
                enable_btn_grabar === false,
              'bg-green-600 hover:bg-green-700 text-white shadow-md':
                enable_btn_grabar === true,
            }"
          >
            Generar pdf
          </button>
          <button
            v-if="showForm === true"
            @click="guardar"
            class="px-6 py-2 rounded-lg transition font-medium"
            :class="{
              'bg-gray-100 text-gray-300 cursor-not-allowed':
                enable_btn_grabar === false,
              'bg-blue-600 hover:bg-blue-700 text-white shadow-md':
                enable_btn_grabar === true,
            }"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import api from "@/api/axios";
import { useIngresos } from "@/composables/useIngresos";

export default {
  name: "ModalIngresoMes",
  emits: ["get_monto_mensual", "recarga_presupuestos_mensuales"],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    centro_id: {
      type: Number,
    },
    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    datosModificacion: {
      type: Object,
    },
    modificaciones_bloqueados: {
      type: Boolean,
    },
    timestamp: {
      type: String,
    },
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {
    // datosModificacion llegan por PROPS al cargar componente

    timestamp: function () {
      this.recargaDatos(this.datosModificacion);
    },
  },
  methods: {
    handleFocusMontoReasignacion(event) {
      this.error_saldo_insuficiente = false;
      this.error_monto_modificacion_ya_alcanzado = false;
      event.target.value = "";
    },
    handleBlurMontoReasignacion(mes, event) {
      console.log("handleblur");
      this.error_saldo_insuficiente = false;
      this.error_monto_modificacion_ya_alcanzado = false;
      const valor = event.target.value;
      let monto = parseFloat(valor);
      if (isNaN(monto)) {
        console.warn("Valor no es numérico");
        event.target.value = "";
        return false;
      }
      this.objMesYMonto = { mes: mes, monto: monto };
      this.agregar_movimiento();
      event.target.value = "";
    },
    agregar_movimiento() {
      if (
        !this.centroSelec ||
        !this.cuentaSelec ||
        !this.presupuesto_id_Selec
      ) {
        return false;
      }
      if (!this.objMesYMonto) {
        return false;
      } else {
        if (
          (typeof this.objMesYMonto === "object" &&
            !("monto" in this.objMesYMonto)) ||
          (typeof this.objMesYMonto === "object" && !this.objMesYMonto.monto) ||
          this.objMesYMonto.monto <= 0
        ) {
          return false;
        }
      }

      console.log("tipo modificacion", this.tipo_modificacion);
      // verificar total movimientos
      const tot_mes_tipeado = parseFloat(this.objMesYMonto.monto);
      let totmov = this.list_movimientos.reduce((total, item) => {
        return total + item.objMesMonto.monto;
      }, 0);

      // controlar que la suma de los movimientos, no supere monto de lo que quiero modificar
      console.log(
        "tot.movimientos realizados (en cualquier cta):",
        totmov,
        "cantidad comprometida para modificar el presup.",
        this.monto_modif
      );

      // total de modificaciones supera al monto solicitado
      if (totmov + tot_mes_tipeado > this.monto_modif) {
        this.error_monto_modificacion_ya_alcanzado = true;
        return false;
      }

      if (this.tipo_modificacion == 1) {
        console.log(
          tot_mes_tipeado,
          " - ",
          parseFloat(this.array_monto_mensual[this.objMesYMonto.mes])
        );
        if (
          tot_mes_tipeado >
          parseFloat(this.array_monto_mensual[this.objMesYMonto.mes])
        ) {
          this.error_saldo_insuficiente = true;
          return false;
        }
      }

      let datoscentroSelec = "";
      let datoscuentaSelec = "";
      const centro = this.centros.find((c) => c.id == this.centroSelec);
      if (centro) {
        datoscentroSelec = `${centro.codigo} - ${centro.nombre}`;
      }
      const cuenta = this.cuentas.find((c) => c.id == this.cuentaSelec);
      if (cuenta) {
        datoscuentaSelec = `${cuenta.codigo} - ${cuenta.nombre}`;
      }

      const presupuesto_inicial_mes= parseFloat(this.array_monto_mensual[this.objMesYMonto.mes]);
      if (this.tipo_modificacion == 2) {
        // si el presupuesto se quiere disminuir, se reasigna sumando
        console.log("sumar lo quitado al presupuesto", tot_mes_tipeado);
        this.array_monto_mensual[this.objMesYMonto.mes] =  presupuesto_inicial_mes +  tot_mes_tipeado;
        this.objMesYMonto.operador = 1;
      } else {
        console.log("restar lo sumado al presupuesto", tot_mes_tipeado); // si el presupuesto se quiere aumentar, debes quitarle a otros
        this.array_monto_mensual[this.objMesYMonto.mes] =  presupuesto_inicial_mes - tot_mes_tipeado;
        this.objMesYMonto.operador = -1;
      }
      this.objMesYMonto.presupuesto_mes_inicial=presupuesto_inicial_mes;
      
      let index = this.list_movimientos.length;
      this.list_movimientos.push({
        indice: index,
        centro: this.centroSelec,
        centro_datos: datoscentroSelec,
        cuenta: this.cuentaSelec,
        cuenta_datos: datoscuentaSelec,
        objMesMonto: this.objMesYMonto,
        presupuesto_id_seleccionado: this.presupuesto_id_Selec,
    
      });

      console.log(
        "presupuesto mensual queda en:",
        this.array_monto_mensual[this.objMesYMonto.mes],
      
      );

      totmov = this.list_movimientos.reduce((total, item) => {
        return total + item.objMesMonto.monto;
      }, 0);

      this.total_movimientos = totmov;
      console.log("total_movimientos queda en:", this.total_movimientos);

      this.porcentaje_movimientos =
        (100 * this.total_movimientos) / this.monto_modif;
      this.saldo_por_completar = this.monto_modif - this.total_movimientos;
      return true;
    },
    borrar_movimiento(indice) {
      let movimiento_seleccionado = this.list_movimientos.filter(
        (item) => item.indice == indice
      );
      const indicemes = parseInt(movimiento_seleccionado[0].objMesMonto.mes);
      const monto_mes_tipeado = parseFloat(
        movimiento_seleccionado[0].objMesMonto.monto
      );
      console.log(
        movimiento_seleccionado[0].centro,
        movimiento_seleccionado[0].cuenta,
        this.centroSelec,
        this.cuentaSelec,
        "<---"
      );

      if (
        movimiento_seleccionado[0].centro == this.centroSelec &&
        movimiento_seleccionado[0].cuenta == this.cuentaSelec
      ) {
        if (this.tipo_modificacion == 2) {
          this.array_monto_mensual[movimiento_seleccionado[0].objMesMonto.mes] =
            parseFloat(this.array_monto_mensual[indicemes]) - monto_mes_tipeado;
        } else {
          this.array_monto_mensual[movimiento_seleccionado[0].objMesMonto.mes] =
            parseFloat(this.array_monto_mensual[indicemes]) + monto_mes_tipeado;
        }
      }
      let list_movimientos_nuevo = this.list_movimientos;
      // recrear la lista, dejando de lado el eliminado
      list_movimientos_nuevo = list_movimientos_nuevo.filter(
        (item) => item.indice !== indice
      );
      this.total_movimientos = list_movimientos_nuevo.reduce((total, item) => {
        return total + item.objMesMonto.monto;
      }, 0);
      console.log("total movimientos", this.total_movimientos);

      this.list_movimientos = list_movimientos_nuevo;
      this.porcentaje_movimientos =
        (100 * this.total_movimientos) / this.monto_modif;
      this.saldo_por_completar = this.monto_modif - this.total_movimientos;

      return true;
    },
    recargaDatos(datProp) {
      /** datProp es datosModificacion
       * { "id": 938, "mes": 2, "monto_mensual": "45567.00", "glosa": "6", "timestamp": "2025-11-26T12:06:13.345021-03:00", "presupuesto_id": 568, "accion_id": "2", "monto_modif": 30000, "reasignar": "true" }
       */
      console.log("recarga", datProp);
      this.reasignar_isOn = false;
      this.enable_btn_grabar = true;
      this.array_monto_mensual.fill(0);
      this.monto_modif = "";
      this.puede_restar = false;
      this.puede_sumar = false;
      this.error_monto = false;
      this.saldo_por_completar = 0;
      this.total_movimientos = 0;
      this.porcentaje_movimientos = 0;
      if (  datProp &&   typeof datProp === "object" &&  !Array.isArray(datProp) &&   "monto_modif" in datProp ) {
        this.monto_presupuesto_mes = datProp.presupuesto_mensual
          ? parseFloat(datProp.presupuesto_mensual)
          : 0;
        this.mes = datProp.mes;
        this.presupuesto_id = datProp.presupuesto_id;
        this.ingreso_id = datProp.id;
        this.tipo_modificacion = parseInt(datProp.accion_id);
        this.monto_modif = datProp.monto_modif;
        this.reasignar_isOn = datProp.reasignar == "true" ? true : false;
        switch (this.tipo_modificacion) {
          case 1:
            this.glosa_accion = "Aumentar Presupuesto";
            this.glosa_operacion = "Sumar";
            break;
          case 2:
            this.glosa_accion = "Disminuir Presupuesto";
            this.glosa_operacion = "Restar";
            break;
        }
      }
      if (this.reasignar_isOn) {
        this.glosa_reasignacion =
          this.tipo_modificacion == 1
            ? `Restar de otra cuenta: `
            : `Sumar a otra cuenta:`;
      }
      if (
        this.presupuesto_id == 0 ||
        this.presupuesto_id == "" ||
        this.mes == 0 ||
        this.mes == ""
      ) {
        this.error_props = true;
      }

      this.saldo_por_completar = this.monto_modif - this.total_movimientos;
      this.centroSelec = 0;
      this.cuentaSelec = 0;
      this.presupuesto_tentativo = this.monto_presupuesto_mes;

      const esSuma = this.tipo_modificacion == 1;
      const operador = esSuma ? 1 : -1;

      this.presupuesto_tentativo =
        this.monto_presupuesto_mes + operador * this.monto_modif;

      this.uploading = false;
      this.uploadProgress= 0;
      this.uploadProgressGlosa=''

      const listado = this.$store.state.cuentas.cuentas;
    listado.forEach((cuenta) => {
      this.cuentas.push({
        codigo: cuenta.codigo,
        id: cuenta.id,
        nombre: cuenta.nombre,
      });
    });

    },
    cerrar() {
      this.resetea_form();
      this.$emit("update:visible", false);
    },

    async guardar() {
      const mes = this.mes;
      const presupuesto_id = this.presupuesto_id;
      if (mes <= 0 || presupuesto_id <= 0) {
        console.log("error general, falta mes, presupuesto_id, ingreso_id");
        this.error_props = true;
        return false;
      }

      const file_url = this.file_url;
      const monto_modificacion = parseFloat(this.monto_modif);
      const total_movimientos = parseFloat(this.total_movimientos);

      if (monto_modificacion == 0 || isNaN(monto_modificacion)) {
        this.error_monto = true;
        return false;
      }

      if (!this.reasignar_isOn) {
        console.log("modificacion simple");
      } else {
        console.log("modificacion con reasignacion");
        console.log("monto:", monto_modificacion);

        if (total_movimientos !== monto_modificacion) {
          this.error_faltan_movimientos = true;
          return false;
        }
      }

      if (!file_url) {
        console.log("falta adjunto");
        this.error_file = true;
        return false;
      }

      try {
        console.log(this.$store.state.auth)
        const data = {
          presupuesto_id:        this.presupuesto_id,
          presupuesto_mes_inicial: this.monto_presupuesto_mes,
          mes_num:               this.mes,
          ingreso_id: this.ingreso_id,
          glosa: this.glosa,
          monto_modificacion: this.monto_modif,
          tipo_modificacion: this.tipo_modificacion,
          con_reasignacion: this.reasignar_isOn,
          movimientos: this.list_movimientos,
          url_adjunto: this.file_url,
          user_id:  this.$store.state.auth.userLogin.id,
     
        };
        
        const url = "api/v1/creacionmodificacion/";

        const resp = await api.post(url, data, {
          headers: {
            "Content-Type": "application/json",
            
          },
        });

        const status = resp.data.status;
        switch (status) {
          case 201:
            console.log("datos enviados ok");
            // remover formulario y mostrar mensaje
            this.showForm = false;
            // volver a llamar api
            this.$emit("recarga_presupuestos_mensuales");
            this.modificacion_id=resp.data.modificacion_id;
            break;
        }
      } catch (err) {
        console.log(err);
      }
    },
    seleccionar_mes(mes) {
      this.error_falta_selec_mes = false;
      this.error_selecciona_cuenta = false;
      this.error_monto = false;
      this.mesSelec = 0;
      const tipo_modificacion = parseInt(this.tipo_modificacion);
      const monto_modificacion = parseFloat(this.monto_modif);
      const monto_mes_seleccionado = parseFloat(this.array_monto_mensual[mes]);
      const total_ingresos = parseFloat(this.monto_presupuesto_mes);

      if (!this.centroSelec || this.centroSelec <= 0) {
        this.error_centro = true;
        return false;
      }

      if (!this.cuentaSelec || this.cuentaSelec <= 0) {
        this.error_cuenta = true;
        return false;
      }

      if (tipo_modificacion == 1) {
        if (monto_modificacion <= 0) {
          console.log("falta ingresar monto", this.monto_modif);
          this.error_monto = true;
          return false;
        } else {
          // if (monto_modificacion > monto_mes_seleccionado) {
          //   console.log('saldo insuficiente', monto_mes_seleccionado,monto_modificacion )
          //   this.error_saldo_insuficiente = true;
          //   }
        }
      }

      if (tipo_modificacion == 2 && total_ingresos < monto_mes_seleccionado) {
        console.log(
          "monto sobrepasado",
          total_ingresos,
          monto_mes_seleccionado
        );
        //  this.mesSelec = 0;
        // this.error_saldo_insuficiente = true
        // return false;
      }

      this.mesSelec = mes;
    },
    handleBlurMonto() {
      /* this.error_monto = false;
       const monto_modificacion = parseFloat(this.monto_modif)
       const monto_presupuesto_mes = parseFloat(this.monto_presupuesto_mes);
       const tipo_modificacion = this.tipo_modificacion;
       if (tipo_modificacion == 1) {
         if (!monto_modificacion || monto_modificacion == 0) {
           console.log('ingrese monto modificacion')
           this.error_monto = true;
           return false;
         }
         if (this.mesSelec && this.mesSelec > 0 && monto_modificacion <= this.array_monto_mensual[this.mesSelec]) {
           this.error_saldo_insuficiente = false;
         }
       } else {
         console.log('blur', monto_presupuesto_mes, monto_modificacion)
         this.error_ingresos_insuficientes = false;
         if (monto_presupuesto_mes < monto_modificacion) {
           console.log('error')
           this.error_ingresos_insuficientes = true;
           return false;
         }
       }
     */
    },

    async onFileChange(event) {
      console.log("Archivo seleccionado:", event.target.files[0]);

      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append("presupuesto_id", this.presupuesto_id);
      formData.append("mes", this.mes);
   
       
      this.uploadProgress = 0;
      this.uploadProgressGlosa='Subiendo archivo...';
      this.uploading = true;
      try {
        const resp = await api.post(
          "/api/v1/upload/modificaciones/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                    this.uploadProgress = Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    );
                   
              }
            },
          }
        );
        this.error_file = false;
        if(resp.data.error )
        {
             alert(resp.data.error);
             this.error_file=true;
             this.uploadProgressGlosa='';
             this.uploadProgress = 0;
             return;
        }  

       
        this.file_url = resp.data.file_url;
        this.uploadProgressGlosa =  resp.data.message  ;
        this.fileKey++;

      } catch (error) {
        console.error("Error al enviar:", error);
        this.uploadProgressGlosa="Error al subir archivo";
      }
    },
    async cambioCuenta() {
      console.log("Nueva selección:", this.cuentaSelec, this.centroSelec);

      if (this.centroSelec == 0) {
        return false;
      }
      this.puede_mostrar_meses = true;

      this.error_saldo_insuficiente = false;
      this.mesSelec = 0;
      this.loading = true;
      const { getIngresos } = useIngresos();

      const resp = await getIngresos(this.centroSelec, this.cuentaSelec);

      this.array_monto_mensual.fill(0);
      this.marca_modificacion.fill("");
      this.extraeValores(resp);
      this.error_cuenta = false;
      this.loading = false;
    },
    async cambioCentro() {
      if (this.cuentaSelec == 0 || this.centroSelec == 0) {
        return false;
      }

      this.puede_mostrar_meses = true;
      this.mesSelec = 0;
      this.error_saldo_insuficiente = false;
      this.loading = true;

      const { getIngresos } = useIngresos();
      const resp = await getIngresos(this.centroSelec, this.cuentaSelec);
      this.array_monto_mensual.fill(0);
      this.marca_modificacion.fill("");

      this.extraeValores(resp);

      this.error_centro = false;
      this.loading = false;
    },
    extraeValores(resp) {
       this.spanresp = resp
      /*  resp.ingresos <<<--- composer  <<<---(API)
         (argumentos:centro_id & cuenta_id).
         Si la base de datos está bien configurada toda consulta args: centro_id + cuenta_id 
         tiene un presupuesto_id correspondiente.

         SIEMPRE recibiras el objeto :       
        {
                "status": 200,
                "total_registros": 0,
                "presupuesto_id": 5464,
                "ingresos_bloqueados": false,
                "total_presupuesto": 0.0,
                "ingresos": [ LOS INGRESOS: aqui van 12 objetos, uno para cada mes,]
                "modificaciones": []
        }         
                ojo: "data" podría venir vacio, ya que quizas depto. de finanzas no consideró 
                 al centro + cuenta al armar presupuestos al principio.
          
      */

      if (!resp ){
        alert('centro + cuenta no tiene un presupuesto creado')
        return false
      }  

      this.presupuesto_id_Selec = resp.presupuesto_id;
      console.log('resp!',resp)
      if (!resp || resp.ingresos.length == 0) {
        for (let mes = 1; mes <= 12; mes++) {
          // revisar si se han tipeado modificaciones en el mes
          // filter: crea un nuevo arreglo filtrado
          const movimientos = this.list_movimientos
            .filter(
              (item) =>
                item.objMesMonto.mes === mes &&
                item.centro === this.centroSelec &&
                item.cuenta === this.cuentaSelec
            )
            .map((item) => item.objMesMonto);
          /* 
          resultado
          [
            { mes: 1, monto: 100, operador: 1 },
            { mes: 1, monto: 1, operador: 1 }
          ]
          */

          for (const mov of movimientos) {
            console.log("mov*", mov);
            // optional chaining
            this.marca_modificacion[mes] = "*";
            const monto = mov ? Number(mov.monto) || 0 : 0;
            const operador = mov ? Number(mov.operador) || 1 : 1;
            const preexistente = Number(this.array_monto_mensual[mes]) || 0;
            this.array_monto_mensual[mes] = preexistente + operador * monto;
          }
        }
      } else {
        if (resp && Array.isArray(resp.ingresos) ) {
          /* 
          Convierte cada objeto del array en un par clave–valor:
          array resp.ingresos:
          [
                {
                    "id": 829,
                    "mes": 1,
                    "monto_mensual": "0.00",
                    "glosa": "Importado desde CSV",
                    "timestamp": "2025-11-25T17:34:02.450465-03:00",
                    "presupuesto_id": 1191
                }
        ]          
        const mapa = Object.fromEntries(
            resp.ingresos.map(item => [item.mes, item.monto_mensual])
          );
        El .map() devuelve:
                [
                  [3, "100.00"],
                  [5, "250.00"]
                ]
                
          Object.fromEntries(...)
              Toma esos pares y los convierte en un objeto tipo diccionario:
              {
              3: "100.00",
              5: "250.00"
              }
              📌 Resultado: se puede acceder directamente por mes → mapa[mes]
          */
        
          const mapa = Object.fromEntries(
            resp.ingresos.map((item) => [item.mes, item.monto_mensual])
          );

          for (let mes = 1; mes <= 12; mes++) {
            // || usa 0 si el resultado no es válido.
            const valor_from_api = Number(mapa[mes]) || 0;
            this.array_monto_mensual[mes] = valor_from_api;
            console.log("monto ingreso", mes, this.array_monto_mensual[mes]);
            // revisar si se han tipeado modificaciones en el mes
            // filter: crea un nuevo arreglo filtrado
            const movimientos = this.list_movimientos
              .filter(
                (item) =>
                  item.objMesMonto.mes === mes &&
                  item.centro === this.centroSelec &&
                  item.cuenta === this.cuentaSelec
              )
              .map((item) => item.objMesMonto);

            /*  movimientos:
            [
              { mes: 1, monto: 100, operador: 1 },
              { mes: 1, monto: 1, operador: 1 }
            ]
            */

            for (const mov of movimientos) {
              this.marca_modificacion[mes] = "*";
              // optional chaining
              const monto = mov ? Number(mov.monto) || 0 : 0;
              const operador = mov ? Number(mov.operador) || 1 : 1;
              this.array_monto_mensual[mes] =
                this.array_monto_mensual[mes] + operador * monto;
            }

            const modificaciones_suma = resp.modificaciones.filter(
              (m) => m.tipo_modificacion == 1 && m.mes == mes
            );
            const modificaciones_resta = resp.modificaciones.filter(
              (m) => m.tipo_modificacion == 2 && m.mes == mes
            );

            let sumas = 0;
            modificaciones_suma.forEach((obj) => {
              sumas += Number(obj.monto) || 0;
            });

            let restas = 0;
            modificaciones_resta.forEach((obj) => {
              restas += Number(obj.monto) || 0;
            });

            this.array_monto_mensual[mes] += sumas;
            this.array_monto_mensual[mes] -= restas;
          }
        }else{
          console.log('no registra ingresos')
        }
      }
      return true;
    },
    resetea_form() {
      this.error_file = false;
      this.error_monto = false;
      this.error_centro = false;
      this.error_cuenta = false;
      this.error_sinsaldo_mensual = false;
      this.error_saldo_insuficiente = false;
      this.error_ingresos_insuficientes = false;
      this.error_falta_selec_mes = false;
      this.error_faltan_movimientos = false;
      this.mesSelec = 0;
      this.file_url = "";
      this.monto_mensual = "";
      this.centroSelec = 0;

      this.cuentaSelec = 0;
      this.fileKey++;
      this.file_url = "";
      this.glosa = "";
      this.enable_btn_grabar = true;
      this.reasignar_isOn = false;
      this.puede_mostrar_meses = false;
      this.list_movimientos = [];
      this.objMesYMonto = {};
      this.glosa_accion = "";
      this.glosa_reasignacion = "";
      this.saldo_por_completar = 0;
      this.presupuesto_id_Selec = "";

      this.showForm = true;
    },
    async pdf(){
        
        const url = this.VUE_APP_DJANGO_API_URL+"/api/v1/descargapdf/"+this.modificacion_id;
        window.open(url)
    }
  },
  data() {
    return {
      loading: false,
      tipo_modificacion: 1,
      monto_presupuesto_mes: 0,
      glosa: "",
      presupuesto_id: 0,
      ingreso_id: 0,
      accion_id: 0,
      mes: 0,
      file_url: "",
      cuentas: [],
      centros: [],
      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],
      monto_mensual: "",
      array_monto_mensual: new Array(13).fill(0),
      marca_modificacion: new Array(13),
      cuentaSelec: 0,
      centroSelec: 0,

      objMesYMonto: {},
      mesSelec: 0,

      reasignar_isOn: false,
      accion: "Disminución",
      error_props: false,
      error_monto: false,
      error_file: false,
      error_cuenta: false,
      error_centro: false,
      error_selecciona_cuenta: false,
      error_saldo_insuficiente: false,
      error_falta_selec_mes: false,
      error_ingresos_insuficientes: false,
      error_monto_modificacion_ya_alcanzado: false,
      error_faltan_movimientos: false,
      fileKey: 0,
      enable_btn_grabar: true,
      puede_restar: false,
      puede_sumar: false,
      puede_mostrar_meses: false,
      porcentaje_movimientos: 0,
      list_total_movimientos: [],
      list_movimientos: [],
      glosa_accion: "",
      glosa_reasignacion: "",
      glosa_operacion: "",
      presupuesto_tentativo: 0,
      total_movimientos: 0,
      saldo_por_completar: 0,
      presupuesto_id_Selec: "",
      showForm: true,
      modificacion_id:0,
      spanresp:'',
      uploadProgress: 0,
      uploading: false,
      uploadProgressGlosa:'',
      VUE_APP_DJANGO_API_URL:''
    };
    /**
     * list_movimientos
     * 
     [{
        "indice":0,
        "centro":37,
        "centro_datos":"VCO069000000000 - Amigos del Parque Pumalin",
        "cuenta":32,
        "cuenta_datos":"4.5.1030.40.15 - Alimentación animales de trabajo",
        "objMesMonto":{
          "mes":5,
          "monto":4
        }
     }]
     */
  },
  mounted() {
    this.VUE_APP_DJANGO_API_URL = process.env.VUE_APP_DJANGO_API_URL
    this.enable_btn_grabar = true;
    this.centroSelec = this.centro_id;

    this.monto_mensual = "";
    this.array_monto_mensual.fill(0);
    this.marca_modificacion.fill("");
    this.file_url = "";
    
    const listado2 = this.$store.state.centros.centros;
    listado2.forEach((centro) => {
      this.centros.push({
        codigo: centro.codigo,
        id: centro.id,
        nombre: centro.nombre,
      });
    });

   this.centros = Object.values(listado2).sort((a, b) =>
      a.nombre.localeCompare(b.nombre)
    ); 

    this.resetea_form();
  },
};
</script>

<style scoped></style>
